import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Box, Typography, IconButton, FormControl, MenuItem, InputLabel, Select, Paper, TextField, Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close, DeleteOutline } from '@material-ui/icons';
import { useTranslate, useDataProvider } from 'react-admin';
import { IconButton as CustomizeIconButton } from '../common/button';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import CustomPopoverArrow from '../CustomizedUIs/CustomPopoverArrow'
import { useSelector, useDispatch } from 'react-redux';
import { changeNodeGlobalData } from '../redux/actions/tree-action';
import { baseApiUrl } from '../dataProvider/sails';
import { Loading } from 'react-admin';
import { usePopupState } from 'material-ui-popup-state/hooks';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton';
import Snackbar from '../common/snackbar';
import { bindToggle } from 'material-ui-popup-state';
import colors from '../CustomizedUIs/Colors'
const useStyles = makeStyles(theme => ({
    dialogCloseBtn: {
        width: '25px',
        height: '25px',
        borderRadius: '10px',
        border: ' solid 2px #e5f1f8',
        backgroundColor: ' #ffffff',
        marginLeft: 10,
        marginRight: 10,
        marginBottom: 50
    },
    textTitle: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
    },

    Rectangle: {
        width: '1170px',
        height: '778px',
        borderRadius: '10px',
        backgroundColor: '#f3f7fa'
    },
    closeBtn: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '10px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.4px',
        color: '#4f5064',
        marginBottom: 50
    },
    paper: {
        padding: '16px 16px',
        width: 300
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '14px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 2.4,
        letterSpacing: '0.15px',
        color: '#4f5064',
    },

    btnSave: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '12.5px',
        letterSpacing: '0.4px',
        color: '#ffffff',
    },


    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
    },
    textLabel: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    borderArrow: {
        borderRadius: '10px',
        backgroundColor: ' #e5f1f8',
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
    },

    focuses: {
        backgroundColor: 'white !important'
    },

}));

const PopupEdit = ({ popupState, value, onClose, onChangeText, onCreate, loading, error }) => {
    const translate = useTranslate();
    const classes = useStyles()
    return (
        <Paper className={classes.paper}>
            <Typography className={classes.TitleCreate} style={{ marginBottom: 8 }}>{translate(`pos.media.createCategory`)}</Typography>
            <TextField
                error={error.status && error.message}
                helperText={error.message}
                onChange={onChangeText}
                onBlur={onChangeText}
                value={value}
                placeholder={translate(`pos.media.categoryName`)}
                FormHelperTextProps={{
                    className: classes.textError
                }}
                InputLabelProps={{
                    // className: classes.textLabel,
                    classes: {
                        root: classes.textLabel,
                        error: classes.textLableError
                    }
                }}
                InputProps={{
                    className: classes.input,
                    classes: {
                        underline: error.message ? classes.underlineError : (value !== '' ? classes.underline : classes.underlineNotValue),
                        focused: classes.focuses
                    }
                }}
                fullWidth />
            <Box mt={1} display='flex' justifyContent='flex-end' width='100%'>
                <Button onClick={onClose} color='primary'>{translate(`pos.common.cancel`)}</Button>
                <Button disabled={error.status || loading} onClick={onCreate} style={{ marginLeft: 8, padding: "5px 8px 5px 8px" }} variant='contained' color='primary'>
                    {loading ? (
                        <CircularProgress
                            size={15}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        <Typography className={classes.btnSave}>{translate(`pos.common.save`)}</Typography>
                    }
                </Button>
            </Box>
        </Paper >
    )
}

function DialogEditor({ open, onClose, nodeData }) {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider()
    const [templates, setTemplates] = useState([]);
    const [template, setTemplate] = useState({ name: 'None' });
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState(nodeData.applicationData.nodeInfo.htmlContent || '');
    const [error, setError] = useState({ status: true, message: '' })
    const [dataCreate, setDataCreate] = useState('')
    const [loadingCreate, setLoadingCreate] = useState(false)
    const popupState = usePopupState({ variant: 'popper', popupId: 'createDialog' })
    const [showSnackbar, setShowSnackbar] = useState({
        name: '',
        status: false
    })
    const getTemplates = () => {
        setLoading(true)
        dataProvider('GET_LIST', "template-editor", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                data.unshift({ name: 'None' })
                setTemplates(data)
                setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })
    }
    useEffect(() => {
        if (open) {
            getTemplates()
            setTemplate({ name: 'None' })
        }

    }, [nodeData, open]);

    useEffect(() => {
        setFormData(template.id ? template.value : nodeData.applicationData.nodeInfo.htmlContent || '');
    }, [template]);


    const onChange = data => {
        if (data)
            setFormData(data);
    }


    const handleChange = (event) => {
        let data = templates.find(item => item.name === event.target.value)
        setTemplate(data);
        // setFormData(data.value ? data.value : "")
    };

    const dispatch = useDispatch();
    const callBackSave = () => {
        const newNode = {
            ...nodeData.applicationData,
            nodeInfo: {
                htmlContent: formData
            }
        };
        dispatch(changeNodeGlobalData(newNode));
        onClose();
    };

    const onClosePopupCreate = () => {
        popupState.close()
        setDataCreate('')
        setError({ status: true, message: '' })
    }

    const onChangeTextCreate = (event) => {
        setDataCreate(event.target.value)
        if (event.target.value.length === 0)
            setError({
                status: true,
                message: 'required'
            })
        else {
            setError({
                status: false,
                message: ''
            })
        }
    }
    const savetemplate = () => {
        setLoadingCreate(true)
        dataProvider('CREATE', "template-editor", {
            data: { name: template.id ? template.name : dataCreate, value: formData }
        })
            .then(({ data }) => {
                if (template.id) {
                    let index = templates.findIndex(item => item.name === data.name)
                    let temps = [...templates]
                    temps[index].value = data.value
                    setTemplates(temps)
                }
                else {
                    let temps = [...templates]
                    if (!temps.find(item => item.name === data.name)) {
                        temps.push(data)
                        setTemplates(temps)
                    }
                    setTemplate(data)
                }

                setLoadingCreate(false)
                popupState.close()
                setShowSnackbar({
                    name: data.name,
                    status: true
                })
                setTimeout(() => {
                    setShowSnackbar({
                        name: '',
                        status: false
                    })
                }, 6000);
            })
            .catch(error => {
                setLoadingCreate(false)
            })
    }
    const handleSave = (event) => {
        if (!template.id)
            popupState.open(event)
        else
            savetemplate()
    }

    const handleDelete = () => {
        dataProvider('DELETE', 'template-editor', {
            id: template.id
        }).then(res => {
            let index = templates.findIndex(item => item.name === template.name)
            let temps = [...templates]
            temps.splice(index, 1)
            setTemplates(temps)
            setTemplate({ name: 'None' })
        }).catch(error => {
            console.error('On Delete:', error);
        });
    }


    return (
        <Dialog disableEnforceFocus={true} maxWidth='lg' open={open} onClose={onClose} aria-labelledby="form-dialog-title">
            {
                loading ?
                    <Loading /> :
                    (
                        <Box style={{ backgroundColor: '#f3f7fa' }} pt={3} width={1170} textAlign='center' alignItems='center' className={classes.Rectangle}>
                            <Snackbar
                                show={showSnackbar.status}
                                boldText={showSnackbar.name}
                                message={translate(`pos.categories.createFolder.success`)}
                                onClose={() => setShowSnackbar({
                                    name: '',
                                    status: false
                                })}
                            />
                            <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                                <Box style={{ marginRight: 'auto', marginLeft: 40 }} >
                                    <Typography className={classes.textTitle}>{translate('pos.common.editor')}</Typography>
                                </Box>
                                <Typography className={classes.closeBtn}>{translate(`pos.user.close`)}</Typography>
                                <IconButton size='small' className={classes.dialogCloseBtn} onClick={onClose}>
                                    <Close color='primary' />
                                </IconButton>
                            </Box>
                            <Box display='flex' justifyContent='flex-start' ml='40px' alignItems='center'>
                                <FormControl style={{ width: 200, backgroundColor: 'white' }}>
                                    <InputLabel id="demo-simple-select-label">template</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={template.name}
                                        onChange={handleChange}
                                    >
                                        {
                                            templates.map((item, index) => (
                                                <MenuItem key={'template-' + index} value={item.name}>{item.name}</MenuItem>
                                            ))
                                        }

                                    </Select>
                                </FormControl>
                                {
                                    template.id && <IconRadiusButton onClick={handleDelete} style={{ padding: '8px', marginLeft: 8 }}
                                        className={classes.borderArrow}>
                                        <DeleteOutline color='primary' />
                                    </IconRadiusButton>
                                }
                                <CustomizeIconButton
                                    style={{ marginLeft: 40 }}
                                    label='Save template'
                                    loading={loadingCreate}
                                    onClick={handleSave}
                                // {...bindToggle(popupState)}
                                />

                            </Box>
                            <Box style={{ margin: 40, overflow: 'scroll' }}>
                                <SunEditor
                                    enableToolbar={true}
                                    defaultValue={formData}
                                    setContents={formData}
                                    setDefaultStyle="font-size: 48px"
                                    onChange={onChange}
                                    setOptions={{
                                        maxHeight: '450px',
                                        minHeight: '450px',
                                        width: '100%',
                                        buttonList: [
                                            ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
                                            ['align', 'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'horizontalRule', 'removeFormat'],
                                            '/', // Line break
                                            ['fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list'],
                                            ['link', 'image', 'table', /*'video', 'fullScreen', */'showBlocks', 'codeView', 'preview'/*, 'print', 'save'*/]
                                        ],
                                        font: [
                                            'Arial', 'Comic Sans MS', 'Courier New', 'Impact',
                                            'Georgia', 'tahoma', 'Trebuchet MS', 'Verdana', 'Dyslexie'
                                        ],
                                        fontSize: [
                                            8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72, 84, 98
                                        ],
                                        imageUploadUrl: `${baseApiUrl}/file/uploadeditor`,
                                        imageWidth: '356.5px'
                                    }} />
                            </Box>
                            <Box display='flex' justifyContent='flex-end' width='100%' mb={3} >


                                <CustomizeIconButton
                                    style={{ marginRight: 40 }}
                                    label={translate('resources.infoPage.save')}
                                    onClick={callBackSave}
                                />
                                <CustomPopoverArrow
                                    zIndex={9999999}
                                    popupState={popupState}
                                    placement='top'
                                >
                                    <PopupEdit
                                        onClose={onClosePopupCreate}
                                        error={error}
                                        onCreate={savetemplate}
                                        value={dataCreate}
                                        onChangeText={onChangeTextCreate}
                                        loading={loadingCreate}
                                        popupState={popupState} />

                                </CustomPopoverArrow>
                            </Box>
                        </Box>
                    )
            }

        </Dialog >
    );
}

DialogEditor.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default DialogEditor;
